<template>
  <loading-overlay v-if="loading" class="animated fadeIn"></loading-overlay>
  <div class="animated fadeIn" v-else>
    <default-heading class="mt-3">
      View Instructions For {{ this.sample_type.name }}
    </default-heading>
    <b-card class="mt-3">
      <div v-html="this.sample_type.service_instructions[0].message"></div>
    </b-card>
  </div>
</template>

<script>

  import DefaultHeading from "../../components/shared/DefaultHeading";
  import SampleTypeModel from "../../models/lab/SampleTypeModel";
  import LoadingOverlay from "../../components/shared/LoadingOverlay";

  export default {
    components: {LoadingOverlay, DefaultHeading},
    name: 'InstructionDetail',
    props: [],
    data() {
      return {
        id: (this.$route.params.id || null),
        loading: true,
        sample_type: null,
      }
    },
    methods: {
      fetch() {
        let sample_type = new SampleTypeModel({id: this.id});
        let p1 = sample_type.fetch().then(() => {
          this.sample_type = sample_type;
        });
        /*let p1 = SampleTypesRepository.get(this.id, {'connection': ['serviceInstructions']}).then((response) => {
          if (response && response.status === 200 && response.data) {
            this.sample_type = response.data;
          }
        });*/
        return Promise.all([p1]);
      },
    },
    mounted() {
      this.loading = true;
      this.fetch().then(() => {
        this.loading = false;
      });
    },
  }
</script>
